import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "60",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      stroke: "#000",
      "stroke-width": "2",
      d: "M32 1.5c2.984 0 5.868 1.517 7.54 4.473l22.213 39.136.003.004c.79 1.405 1.244 2.991 1.244 4.542 0 2.437-.813 4.657-2.36 6.275-1.552 1.624-3.776 2.57-6.455 2.57H9.816c-2.679 0-4.903-.946-6.456-2.57C1.813 54.312 1 52.092 1 49.655c0-1.532.388-3.098 1.257-4.562L24.455 5.98l.158-.274C26.283 2.92 29.115 1.5 32 1.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFD51B",
      d: "m38.67 6.466 22.214 39.137C61.599 46.876 62 48.295 62 49.655c0 4.43-2.948 7.845-7.815 7.845H9.815C4.948 57.5 2 54.084 2 49.655c0-1.36.344-2.75 1.116-4.052L25.33 6.466C26.79 3.832 29.366 2.5 32 2.5s5.181 1.332 6.67 3.966m-9.847 38.297c0 1.708 1.488 3.098 3.206 3.098 1.689 0 3.177-1.361 3.177-3.098 0-1.766-1.46-3.126-3.177-3.126-1.747 0-3.206 1.39-3.206 3.126m.486-24.75.372 15.747c.029 1.535.86 2.403 2.348 2.403 1.402 0 2.232-.84 2.261-2.402l.43-15.719c.028-1.534-1.174-2.663-2.72-2.663-1.603 0-2.72 1.1-2.69 2.634"
    }, null, -1)
  ])))
}
export default { render: render }